export const inspectionCheck = [
  {
    title: '仕上げプレス',
    name: 'finishingPress',
  },
  {
    title: '股下寸法',
    name: 'inseamDimension',
  },
  {
    title: 'ウエスト寸法',
    name: 'waistSize'
  },

  {
    title: '検針器',
    name: 'needleDetector'
  },
  {
    title: '仕様確認',
    name: 'specificationConfirmation'
  },
  {
    title: 'まとめ（まつり）',
    name: 'summaryFestival'
  },
  {
    title: 'カン止め・ステッチ',
    name: 'canStopStitch'
  },
  {
    title: 'ボタン付け',
    name: 'attachButton'
  },
  {
    title: 'ミシン縫い①ポケット袋',
    name: 'pocketBag'
  },
  {
    title: 'ミシン縫い②ポケット口布',
    name: 'pocketOpeningCloth'
  },
  {
    title: 'ブランドネーム',
    name: 'brandName'
  },
  {
    title: '品質記入確認',
    name: 'qualityEntryConfirmation'
  },
  {
    title: '糸処理①ごみ',
    name: 'garbage'
  },
  {
    title: '糸処理②裾しつけ',
    name: 'hemBasting'
  }
]
